// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__LmG1-","tab":"ProcedureTabs_tab__2QlkF"};